import Vue from 'vue';
import VueRouter from 'vue-router';
import VueCookies from 'vue-cookies';

import { store } from '../store/index';
import { isMobile } from '../utils/mobileChecker';
import { handleException } from '../utils/handler';

const lazyLoading = {
  SurveyView: () => import('../views/SurveyView'),
  OfferView: () => import('../views/OfferView'),
  PlanView: () => import('../views/PlanView'),

  NotFoundView: () => import('../views/NotFound'),
  MessageView: () => import('../views/MessageView'),
};

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/plan',
    },
    {
      path: '/survey',
      name: 'survey',
      component: lazyLoading.SurveyView,
      meta: { requiresAuth: true },
      beforeEnter: (to, from, next) => {
        if (isMobile()) {
          next({
            path: '/message/device',
          });
        }

        store
          .dispatch('CHECK_SURVEY_POSB')
          .then(({ data }) => {
            if (data.data.isSurveyPosb) {
              store
                .dispatch('FETCH_SURVEY_QUESTION')
                .then(() => next())
                .catch((error) => handleException(error));
            } else {
              next({
                path: '/message/exists', //'/plan',
              });
            }
          })
          .catch((error) => handleException(error));
      },
    },
    {
      path: '/offer',
      name: 'offer',
      component: lazyLoading.OfferView,
      meta: { requiresAuth: true },
      beforeEnter: (to, from, next) => {
        //console.log(from);
        //console.log(to);
        store
          .dispatch('FETCH_STUDY_PLAN_PREVIEW', to.query)
          .then(() => next())
          .catch((error) => handleException(error));
      },
    },
    {
      path: '/plan',
      name: 'plan',
      component: lazyLoading.PlanView,
      beforeEnter: (to, from, next) => {
        store
          .dispatch('FETCH_STUDY_PLAN', to.query)
          .then(() => next())
          .catch((error) => handleException(error));
      },
    },

    {
      path: '/message/:type',
      name: 'message',
      component: lazyLoading.MessageView,
    },
    {
      path: '*',
      name: 'notfound',
      component: lazyLoading.NotFoundView,
    },
  ],
});
router.beforeEach((to, from, next) => {
  if (to.query.progress !== undefined) {
    store.state.progress = to.query.progress;
  }
  
  if (to.name !== 'message' && store.state.progress === '') {
    alert('과정코드를 확인하세요.');
  }

  if (to.matched.some((r) => r.meta.requiresAuth)) {
    if (
      VueCookies.get('EDWAUTH01') === null &&
      VueCookies.get('ck%5Flogin') === null
    ) {
      next({
        path: '/message/login',
        query: { redirect: location.origin + to.fullPath },
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export { router };
